<template>
    <modal
        v-if="lang"
        name="custom-offer"
        ref="custom-offer"
        extra-class="full-screen-modal custom-offer-modal"
        :title="trans('title')"
    >
        <template slot="body">
            <div class="custom-offer-form">
                <form @submit.prevent="sendLead" @keydown="form.errors.clear($event.target.name)">
                    <div class="form-group">
                        <my-input
                            v-model="formatted_offer"
                            type="text"
                            :label="trans('labels.offer')"
                            @input="formatOffer"
                        >
                            <template v-slot:append>
                                &euro;
                            </template>
                        </my-input>
                        <input type="hidden" name="offer" v-model="form.offer" />
                        <error-span :error="form.errors.get('offer')"></error-span>
                    </div>

                    <div class="form-group">
                        <my-input
                            v-model="form.email"
                            name="email"
                            type="email"
                            :label="trans('labels.email')"
                        />
                        
                        <error-span :error="form.errors.get('email')"></error-span>
                    </div>

                    <div class="form-group">
                        <my-input
                            v-model="form.phone"
                            name='phone'
                            type="phone"
                            :label="trans('labels.phone')"
                        />

                        <error-span :error="form.errors.get('phone')"></error-span>
                    </div>

                    <div class="form-group">
                        <my-input
                            v-model="form.first_name"
                            name="first_name"
                            :label="trans('labels.first_name')"
                        />

                        <error-span :error="form.errors.get('first_name')"></error-span>
                    </div>

                    <div class="form-group">
                        <my-input
                            v-model="form.last_name"
                            name="last_name"
                            :label="trans('labels.last_name')"
                        />

                        <error-span :error="form.errors.get('last_name')"></error-span>
                    </div>

                    <div class="privacy-policy" v-html="trans('agreements.privacy', { link: lang.agreements.link })"></div>

                    <button class="btn btn-network">
                        {{ trans('labels.send') }}
                    </button>
                </form>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '../Modal'

import { Form } from '../../classes/Form'
import { numberFormat , getNumber} from '../../helpers/numbers'

export default {
    components: {
        'modal': Modal,
    },

    props: {
        estate: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            formatted_offer: '',
            form: new Form({
                agency_id: this.estate.agency.id,
                current_page: window.location.href,
                email: '',
                estate_id: this.estate.id,
                estate_price: this.estate.numeric_price,
                first_name: '',
                last_name: '',
                offer: '',
                phone: '',
            }),

            rules: {
                email: ['required', 'email'],
                first_name: ['required'],
                last_name: ['required'],
                offer: ['required', 'min:' + this.minOffer(), 'max:' + this.estate.numeric_price],
                phone: ['required', 'numeric', 'min:9'],
            },
        }
    },

    computed: {
        lang() {
            return this.$root.lang.custom_offer
        },
    },
    watch: {
        formatted_offer:{
            deep:true,
            handler(){
                this.form.offer = getNumber(this.formatted_offer)
            }
        }
    },

    methods: {
        numberFormat(number) {
            return numberFormat(number, 0 , ',', '.')
        },

        formatOffer(event){
            let new_offer = getNumber(event)
            if(new_offer > 0)
            {
                new_offer = new_offer > 0
                    ? new_offer
                    :   0 
                if(new_offer == this.formatted_offer){
                    this.formatted_offer = event
                }

                this.$nextTick(()=>{
                    this.formatted_offer = this.numberFormat(new_offer)
                })
                
            }
        },
        minOffer() {
            return this.estate.numeric_price * 0.75
        },

        sendLead() {
            if(! this.form.validate(this.rules)) {
                return false
            }

            this.form.post('/api/custom-offers')
                .then(data => {
                    if(data.status === 'ko') {
                        flash(this.trans('flash.too_low'))
                    }
                    else {
                        flash(this.trans('flash.success'))

                        if (window.trackLibrary) {
                            setTimeout(() =>
                                window.trackLibrary.track('actions.ribassiImmobile',{
                                    immobile_id: this.estate.id,
                                    agenzia_id: this.estate.agency.id,
                                    tipoPagina: 'ribasso',
                                    nazione: this.estate.country,
                                    origine: 'portale'
                                })
                            , 100)
                        }
  
                         window.events.$emit('hideModal', { name: 'custom-offer' })
                    }
                })
        },
    },
}
</script>